import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { BannerService, CityService, StoreService } from 'src/generated_client';

@Component({
  selector: 'app-add-banner',
  templateUrl: './add-banner.component.html',
  styleUrls: ['./add-banner.component.css']
})
export class AddBannerComponent implements OnInit {
  id: any;
  isEdit: boolean = false;
  title: string = "";
  allCities: CityOption[] = [];
  allStores: StoreOption[] = [];

  status = [
    { value: true, viewValue: 'Activo' },
    { value: false, viewValue: 'Desactivado' },
  ];

  position = [
    { value: 1, viewValue: 'Arriba' },
  ]

  addBannerForm: FormGroup = this.fb.group({
    CdBanner: [],
    CdCity: ['', Validators.required],
    DsImageUrl: [''],
    Image: [''],
    IsActive: ['', Validators.required],
    NmPosition: ['', Validators.required],
    StoresIds: [[]],
  })

  constructor(
    public cityService: CityService,
    public storeService: StoreService,
    public bannerService: BannerService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private snackBar: SnackBarService
  ) {
  }

  ngOnInit() {
    this.id = this.activatedRoute.snapshot.paramMap.get("id")
    if (this.id != null) {
      this.isEdit = true;
      this.bannerService.apiBannerGetOneGet(this.id).subscribe(banner => {
        this.addBannerForm.controls['CdBanner'].setValue(Number(this.id));
        this.addBannerForm.controls['CdCity'].setValue(banner.cdCity);
        this.addBannerForm.controls['DsImageUrl'].setValue(banner.dsImageUrl);
        this.addBannerForm.controls['IsActive'].setValue(banner.isActive);
        this.addBannerForm.controls['NmPosition'].setValue(banner.nmPosition);
        this.addBannerForm.controls['StoresIds'].setValue(banner.idsStore);
      })
    } else {
      this.addBannerForm.controls['Image'].setValidators(Validators.required);
    };

    this.cityService.apiCityGetAllCitiesGet().subscribe(cities => {
      cities.forEach(c => {
        let city: CityOption;
        city = {
          id: Number(c.cdCity),
          name: String(c.dsName)
        }
        this.allCities.push(city)
      });
    });

    this.storeService.apiStoreGetAllStoresGet().subscribe(stores => {
      stores.forEach(s => {
        let store: StoreOption;
        store = {
          id: Number(s.cdStore),
          name: String(s.dsName)
        };
        this.allStores.push(store)
      })
    })

    this.changeTitle();
  }

  changeTitle() {
    if (this.isEdit) {
      this.title = "EDITAR BANNER";
    } else {
      this.title = "AGREGAR NUEVO BANNER";
    }
  }

  saveChanges(form: any) {

    if (this.isEdit) {

      this.bannerService.apiBannerPutPutForm(form.CdBanner, form.CdCity, form.Image._files[0],undefined, form.IsActive, form.NmPosition, form.StoresIds).subscribe(response => {

        this.router.navigate(['banners-management']);
        this.snackBar.openSnackBar('Los cambios fueron guardados','Aceptar')
      },
        (err) => {
          console.log(err)
          this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
        });
    }
    else {

      this.bannerService.apiBannerPostPostForm(form.CdCity, undefined, form.Image._files[0], form.IsActive, form.NmPosition, form.StoresIds).subscribe(response => {

        this.router.navigate(['banners-management']);
        this.snackBar.openSnackBar('Los cambios fueron guardados','Aceptar')
      },
        (err) => {
          this.snackBar.openSnackBar('Ocurrió un error y los cambios no pudieron guardarse.', 'Aceptar')
        });
    }
  }

  get DsImageUrl() {
    return this.addBannerForm.controls['DsImageUrl'].value;
  }

}

interface CityOption {
  id: number;
  name: string;
}

interface StoreOption {
  id: number;
  name: string;
}
